// src/services/db.js
const DB_NAME = 'pokerTimerDB';
const DB_VERSION = 1;
const SOUND_STORE_NAME = 'soundEffectsStore';

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(SOUND_STORE_NAME)) {
        db.createObjectStore(SOUND_STORE_NAME, { keyPath: 'id' });
      }
    };
    request.onsuccess = (event) => resolve(event.target.result);
    request.onerror = (event) => {
      reject(event.target.error);
    };
  });
}

async function execute(storeName, mode, operation) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction(storeName, mode);

    transaction.oncomplete = () => {
      db.close();
    };

    transaction.onerror = (event) => {
      db.close();
      reject(event.target.error);
    };

    const store = transaction.objectStore(storeName);
    const request = operation(store);

    request.onsuccess = () => {
      resolve(request.result);
    };
    request.onerror = (event) => {
      reject(event.target.error);
    };
  });
}

export function saveSoundEffect(id, name, fileBlob) {
  return execute(SOUND_STORE_NAME, 'readwrite', (store) => store.put({ id, name, file: fileBlob }));
}

export function getSoundEffect(id) {
  if (!id) return Promise.resolve(undefined);
  return execute(SOUND_STORE_NAME, 'readonly', (store) => store.get(id));
}

export async function checkSoundExists(id) {
  if (!id) return false;
  try {
    const result = await execute(SOUND_STORE_NAME, 'readonly', (store) => store.getKey(id));
    return result !== undefined;
  } catch (e) {
    return false;
  }
}